import { computed } from 'vue'
import { useStore } from '../store/index'
import { blogMinotariaActivo } from '../plantillas/minotaria'

/** Entrada del blog tal como la guarda el panel (CRUDBlog). */
export interface EntradaBlog {
  id: number
  Titulo: string
  Subtitulo?: string
  Slug: string
  Fecha?: string
  Autor?: string
  Imagen?: string
  Extracto?: string
  Contenido?: string
  Categorias?: string[]
  Publicado?: boolean
  MostrarHome?: boolean
  MostrarCompartir?: boolean
}

// El panel guarda la fecha como "YYYY-MM-DD HH:mm:ss" o, en entradas antiguas, "DD/MM/YYYY, HH:mm:ss"
function marcaTiempo(fecha?: string): number {
  if (!fecha) return 0
  const m = fecha.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:[\s,]+(\d{1,2}):(\d{2})(?::(\d{2}))?)?/)
  if (m) return new Date(+m[3], +m[2] - 1, +m[1], +(m[4] ?? 0), +(m[5] ?? 0), +(m[6] ?? 0)).getTime()
  const t = new Date(fecha.replace(' ', 'T')).getTime()
  return isNaN(t) ? 0 : t
}

export function fechaEntrada(fecha?: string): string {
  const t = marcaTiempo(fecha)
  return t ? new Date(t).toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' }) : ''
}

export function minutosLectura(html?: string): number {
  const palabras = (html || '').replace(/<[^>]*>/g, ' ').trim().split(/\s+/).filter(Boolean).length
  return Math.max(1, Math.ceil(palabras / 200))
}

/** Blog de minotaria.es: entradas publicadas, de la más reciente a la más antigua. */
export function useMinotariaBlog() {
  const store = useStore()
  const activo = computed(() => blogMinotariaActivo(store.NOTARIA))
  const entradas = computed<EntradaBlog[]>(() =>
    ((store.NOTARIA?.Blog || []) as EntradaBlog[])
      .filter((e) => e.Publicado && e.Slug)
      .sort((a, b) => marcaTiempo(b.Fecha) - marcaTiempo(a.Fecha)))
  const categorias = computed(() => [...new Set(entradas.value.flatMap((e) => e.Categorias || []))].sort((a, b) => a.localeCompare(b, 'es')))
  // En la portada, las marcadas "Mostrar en Home"; si no hay ninguna, las últimas
  const destacadas = computed(() => {
    const marcadas = entradas.value.filter((e) => e.MostrarHome)
    return (marcadas.length ? marcadas : entradas.value).slice(0, 3)
  })
  return { activo, entradas, categorias, destacadas }
}
